// extracted by mini-css-extract-plugin
export default {"center":"TitleCenter_center__Z1sdC","title-black":"TitleCenter_title-black__awVu9"};